import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  NgZone,
  OnInit,
} from '@angular/core';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { EmploymentInviteeStatusEnum } from 'server/shared/models/employmentInviteeStatusEnum';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-employment-invitee-status-icon',
  templateUrl: './employment-invitee-status-icon.component.html',
  styleUrls: ['./employment-invitee-status-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmploymentInviteeStatusIconComponent implements OnInit {
  i18n = this.translationService.getTranslations('employments');

  status$ = new BehaviorSubject<EmploymentInviteeStatusEnum | undefined>(
    undefined,
  );
  @Input() set status(status: EmploymentInviteeStatusEnum | undefined) {
    this.status$.next(status);
  }
  get status(): EmploymentInviteeStatusEnum | undefined {
    return this.status$.value;
  }

  displayShowHistoryTooltip$ = new BehaviorSubject<boolean>(false);
  @Input()
  set displayShowHistoryTooltip(value: BooleanInput) {
    this.displayShowHistoryTooltip$.next(coerceBooleanProperty(value));
  }
  get displayShowHistoryTooltip() {
    return this.displayShowHistoryTooltip$.value;
  }

  tooltip$ = combineLatest([
    this.status$,
    this.displayShowHistoryTooltip$,
  ]).pipe(
    map(([status, displayShowHistoryTooltip]) => {
      if (!status) return '';
      const baseTooltip = this.getTooltipForStatus(status);
      if (displayShowHistoryTooltip) {
        return baseTooltip ? baseTooltip + ' | ' + this.i18n?.showHistory : '';
      }
      return baseTooltip;
    }),
  );

  constructor(
    private ngZone: NgZone,
    private translationService: TranslationService,
  ) {}

  ngOnInit() {}

  getTooltipForStatus(status: EmploymentInviteeStatusEnum): string {
    switch (status) {
      case EmploymentInviteeStatusEnum.AVAILABLE:
        return this.i18n?.available || '';
      case EmploymentInviteeStatusEnum.UNAVAILABLE:
        return this.i18n?.unavailable || '';
      case EmploymentInviteeStatusEnum.BOOKED:
        return this.i18n?.booked || '';
      case EmploymentInviteeStatusEnum.DECLINED:
        return this.i18n?.declined || '';
      case EmploymentInviteeStatusEnum.CANCELLED:
        return this.i18n?.canceled || '';
      case EmploymentInviteeStatusEnum.POSSIBLE_CANDIDATE:
        return this.i18n?.possibleCandidate || '';
      default:
        return this.i18n?.open || '';
    }
  }

  readonly employmentInviteeStatusEnum = EmploymentInviteeStatusEnum;
}
